var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-primary tab-header" }, [
    _c("h5", { staticClass: "p-3 bg-primary my-auto" }, [
      _vm._v(" " + _vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pr-5 pd-0 col-sm-6 search" },
      [
        _vm.isSuperAdmin
          ? _c("h5", { staticClass: "p-3 col-sm-3 bg-primary my-auto" }, [
              _vm._v(" " + _vm._s(_vm.$t("USERS.ACCOUNT")) + " ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isSuperAdmin
          ? _c(
              "b-input-group",
              { staticClass: "p-2 col-sm-3 input-group" },
              [
                _c("b-form-select", {
                  staticClass: "selectbox",
                  attrs: { plain: true, options: _vm.accounts },
                  on: { input: _vm.filterByAccount },
                  model: {
                    value: _vm.selectedAccount,
                    callback: function($$v) {
                      _vm.selectedAccount = $$v
                    },
                    expression: "selectedAccount"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("h5", { staticClass: "p-3 col-sm-2 bg-primary my-auto" }, [
          _vm._v(" " + _vm._s(_vm.$t("USERS.ROLE")) + " ")
        ]),
        _vm._v(" "),
        _c(
          "b-input-group",
          { staticClass: "p-2 col-sm-4 input-group" },
          [
            _c("b-form-select", {
              staticClass: "selectbox",
              attrs: { plain: true, options: _vm.roles },
              on: { input: _vm.filterByRole },
              model: {
                value: _vm.selectedRole,
                callback: function($$v) {
                  _vm.selectedRole = $$v
                },
                expression: "selectedRole"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "p-3 pr-5 pd-0 col-lg-3 search" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "b-input-group",
          [
            _c("b-form-input", {
              ref: "searchInput",
              staticClass: "search-text",
              attrs: { placeholder: _vm.$t("WORKFLOW.SEARCH") },
              on: { input: _vm.emitInput }
            }),
            _vm._v(" "),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showClear,
                  expression: "showClear"
                }
              ],
              staticClass: "clear-btn",
              domProps: { innerHTML: _vm._s(_vm.svg.broom) },
              on: { click: _vm.clearFilter }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search-icon" }, [
      _c("i", { staticClass: "fa fa-search" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b21c61e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b21c61e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/UsersSearchBar.vue
// module id = 1294
// module chunks = 2